import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react/dist/iconify.js";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "./CallPermissionModal.css";
import Loader from "../Components/Loader";
import { setMakeCall } from "../Store/Actions/CallAction";
import { getWABAPermission } from "../Store/Actions/WABAAction";

const CallPermissionModal = ({
  contactID,
  recipientPhoneNo,
  WABAAccountID,
  onClose,
  setIsSendingCallPermissionRequest,
  setOpenModalCallPermission,
  setOpenModalNewChat,
}) => {
  const [isGettingPermission, setIsGettingPermission] = useState(true);
  const [permission, setPermission] = useState(null);
  const dispatch = useDispatch();
  const { CurrentState } = useSelector((state) => state.auth);

  useEffect(() => {
    getWABAPermission(recipientPhoneNo, WABAAccountID)
      .then((response) => {
        if (response.status) {
          setPermission(response.data);
          setIsGettingPermission(false);
        } else {
          console.log("error", response.error);

          toast.error("Error getting call permission", {
            autoClose: 3000,
          });

          setIsGettingPermission(false);
        }
      })
      .catch((err) => {
        console.log("err", err);

        toast.error("Error getting call permission", {
          autoClose: 3000,
        });

        setIsGettingPermission(false);
      });
  }, []);

  return (
    <div className="overlayHistory">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer call-permission-modal"
      >
        <div className="modalRight">
          <CloseOutlinedIcon className="closeBtn" onClick={onClose} />

          <div className="content">
            <h1>Call Permission</h1>
          </div>

          <div className="AssignAgentBody">
            {isGettingPermission ? (
              <Loader />
            ) : permission !== null ? (
              <>
                <p className="permission-status">
                  Status: {permission.call_permission.status}
                </p>

                <p className="choose-action">Choose action:</p>

                <div className="action-list">
                  <div className="action selection call">
                    <div className="name-selected">
                      <p className="action-name">Call Customer</p>
                    </div>

                    <Icon height="80" icon="material-symbols:call" />

                    <div>
                      <button
                        className={"btn_Confirm"}
                        disabled={
                          permission.actions[1]?.boleh_dilakukan !== "Ya"
                        }
                        onClick={() => {
                          setOpenModalCallPermission(false);

                          dispatch(
                            setMakeCall({
                              agentStatus: CurrentState,
                              contactID: contactID,
                              isWACall: true,
                              phoneNo: `999${recipientPhoneNo}`,
                            })
                          );
                        }}
                      >
                        Call
                      </button>

                      <div className="limit">
                        <p className="selected-amount">
                          {permission.actions[1]?.limit[0].periode}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="action selection request">
                    <div className="name-selected">
                      <p className="action-name">Request Permission</p>
                    </div>

                    <Icon height="80" icon="mdi:message-question" />

                    <div>
                      <button
                        className={"btn_Confirm"}
                        disabled={
                          permission.actions[0].boleh_dilakukan !== "Ya"
                        }
                        onClick={() => {
                          setIsSendingCallPermissionRequest(true);
                          setOpenModalNewChat(true);
                          setOpenModalCallPermission(false);
                        }}
                      >
                        Request
                      </button>

                      <div className="limit">
                        <p className="selected-amount">
                          {permission.actions[0].limit[0].periode}
                        </p>

                        <p className="selected-amount">
                          {permission.actions[0].limit[1].periode}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <p className="call-permission-error">
                Error getting call permission. Please try again later.
              </p>
            )}
          </div>

          <div className="btnContainer" />
        </div>
      </div>
    </div>
  );
};

export default CallPermissionModal;
